import { AutoCompleteItem } from "@/components/construction-site";
import { ax } from "@/core";
import { createConstructionSiteAutoCompleteOptions } from "@/util/construction-site";
import type { ConstructionSite, IGetConstructionSitesByWorkspaceApiResponse } from "@msuite/katana";
import {
	AutoComplete,
	type AutoCompleteOption,
	FormControl,
	FormLabel,
	useApi,
} from "@msuite/picasso";
import type { FC } from "react";

/** Props Interface */
interface ConstructionSitePickerProps {
	onSelect: (constructionSite: ConstructionSite) => void;
}

export const ConstructionSitePicker: FC<ConstructionSitePickerProps> = ({ onSelect }) => {
	/** Hooks */
	const { data } = useApi<IGetConstructionSitesByWorkspaceApiResponse>(ax, {
		url: "/v2/construction-sites/all?fields=id,nummer,bauvorhaben,strasse,plz,ort,hausnummer",
		dependencies: ["construction-sites"],
	});

	const options = createConstructionSiteAutoCompleteOptions(data?.constructionSites ?? []);

	/** Functions */
	function handleOnSelect(value: AutoCompleteOption<ConstructionSite> | undefined) {
		if (!value?.item) return;
		onSelect(value.item);
	}

	/** Render */
	return (
		<FormControl>
			<FormLabel>Bauvorhaben</FormLabel>
			<AutoComplete<ConstructionSite>
				placeholder="Bauvorhaben suchen"
				options={options}
				renderItem={AutoCompleteItem}
				onChange={handleOnSelect}
			/>
		</FormControl>
	);
};
